import React, { Component } from 'react';
import RUTransportsTable from './UsedRentalsTable/RUTransportsTable';
import RUTransportsTableEdit from './UsedRentalsEdit/RUTransportsTableEdit';


export class RUTransportsByLotContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      content: this.props.showContent,
      negotiationLotId: 0
    };
  }

  handleChangeShowContent = (newContent, negotiationLotId) => {
    this.setState({
      content: newContent,
      negotiationLotId: negotiationLotId
    });
  };


  render() {

    return (
      <div>
        {this.state.content === 'ruTransportsByLot' ?
          <RUTransportsTable handleChangeContent={this.props.handleChangeContent.bind(this)} handleChangeShowContent={this.handleChangeShowContent.bind(this)} />
          : this.state.content === 'ruTransportsByLotEdit' ?
            <RUTransportsTableEdit handleChangeContent={this.props.handleChangeContent.bind(this)} handleChangeShowContent={this.handleChangeShowContent.bind(this)} negotiationLotId={this.state.negotiationLotId} />
            : null
        }
      </div>
    )

  }
}

export default RUTransportsByLotContent;


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsTransport/UsedRentalsByLot/RUTransportsByLotContent.js